import React, { Component } from "react";
import { Link, Redirect } from 'react-router-dom';
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import $ from "jquery";

import { singleSignOnOAuth } from "../../../config/client_api_calls";
import {
  clearClientSession,
  encrypt,
  setSessionTimerCookies,
  getParentDomain,
  COOKIE_OPTS,
} from "../../../config/cookieUtils";

export default class SsoAuthentication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      successMessage: "",
    };
  }

  pythonDecrypt = (encryptedData, passphrase) => {
    // Decode the URL-safe Base64 back to regular Base64
    const base64Encoded = encryptedData.replace(/-/g, "+").replace(/_/g, "/");

    const jsonString = CryptoJS.enc.Utf8.stringify(
      CryptoJS.enc.Base64.parse(base64Encoded)
    );
    const json = JSON.parse(jsonString);

    const iv = CryptoJS.enc.Base64.parse(json.iv);
    const encrypted = json.data;

    const secretKey = CryptoJS.enc.Hex.parse(passphrase);

    const decrypted = CryptoJS.AES.decrypt(encrypted, secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  };

  async componentDidMount() {
    const { reseller_url, token } = this.props.match.params;

    // console.log("token", token);
    // console.log("reseller_url", reseller_url);

    if (reseller_url === "") {
      this.setState({
        errorMessage: "URL is not valid. Please enter the valid URL.",
      });
    } else {
      const passphrase = process.env.REACT_APP_CARRIER_VOICE_ALERTS_SECRET_KEY;

      let decryptedData;
      try {
        decryptedData = this.pythonDecrypt(token, passphrase);
        // console.log("Decrypted data:", decryptedData);
      } catch (error) {
        console.error("Error decrypting token:", error);
        this.setState({
          errorMessage: "Failed to decrypt the token.",
        });
        return;
      }
      let parsedData;
      try {
        parsedData = JSON.parse(decryptedData);
        // console.log("Parsed Data:", parsedData);
      } catch (error) {
        console.error("Error parsing decrypted data:", error);
        this.setState({
          errorMessage: "Failed to parse the decrypted token data.",
        });
        return;
      }

      const {
        email,
        username,
        user_type,
        parent_accountno,
        client_id,
        redirect_url,
        return_url,
        service_id,
        directsso,
      } = parsedData;

      let apiHit = await singleSignOnOAuth(email, reseller_url, client_id);
      // console.log("apiHit.data: ", apiHit.data);
      if (
        apiHit.data.status === 404 &&
        apiHit.data.message === "Invalid or Expired Token."
      ) {
        //window.location.replace("/error");
        this.setState({
          errorMessage: "Invalid credentials or expired token.",
          successMessage: "",
        });
      } else if (
        apiHit.data.status === 200 &&
        apiHit.data.message === "success"
      ) {
        //Remove Previous Session — reliable cleanup on all paths/domains
        console.info("[SSO] OAuth: Clearing previous client session cookies");
        clearClientSession();

        if (return_url && return_url !== "") {
          Cookies.set("client_return_url__", encrypt(return_url), COOKIE_OPTS);
        }
        Cookies.set("client_name__", encrypt(username), COOKIE_OPTS);
        Cookies.set("client_tkn__", encrypt(apiHit.data.token), COOKIE_OPTS);
        Cookies.set("client_acn__", encrypt(apiHit.data.accountno), COOKIE_OPTS);
        Cookies.set("client_eml__", encrypt(email), COOKIE_OPTS);
        Cookies.set("client_comp_nme__", encrypt(apiHit.data.comp_name), COOKIE_OPTS);
        Cookies.set("client_title__", encrypt(apiHit.data.title), COOKIE_OPTS);
        Cookies.set("client_phone__", encrypt(apiHit.data.phone), COOKIE_OPTS);
        Cookies.set("client_adress__", encrypt(apiHit.data.address), COOKIE_OPTS);
        Cookies.set("client_country__", encrypt(apiHit.data.country), COOKIE_OPTS);
        Cookies.set("client_user_type__", encrypt(apiHit.data.user_type), COOKIE_OPTS);
        Cookies.set("client_parent_accountno__", encrypt(apiHit.data.parent_accountno), COOKIE_OPTS);
        Cookies.set("residentifier__", encrypt(apiHit.data.reseller_domain_identifier), COOKIE_OPTS);
        Cookies.set("reslogo__", encrypt(apiHit.data.reseller_logo), COOKIE_OPTS);
        Cookies.set("restkn__", encrypt(apiHit.data.reseller_hash), COOKIE_OPTS);
        Cookies.set("resacct__", encrypt(apiHit.data.reseller_accountno), COOKIE_OPTS);
        Cookies.set("filer_id__", encrypt(apiHit.data.filer_id), COOKIE_OPTS);

        // Set session timer cookies (4h default, or use backend-provided expiry)
        const tokenExpiryMs = apiHit.data.token_expiry || null;
        setSessionTimerCookies(tokenExpiryMs);
        console.info("[SSO] OAuth: Session timer cookies set");

        // Track SSO handshake for logout flow
        localStorage.setItem("client_sso_handshake", "Yes");

        // Cross-subdomain session indicator
        try {
          const _parentDomain = getParentDomain();
          if (_parentDomain) {
            Cookies.set('client_sl_session__', '1', { path: '/', domain: _parentDomain, expires: 1 });
          }
        } catch (_e) {}
        this.setState({
          errorMessage: "",
          successMessage: "Account authenticated successfully.",
        });
        setTimeout(function () {
          if (redirect_url && redirect_url !== "") {
            if (redirect_url === "profile") {
              if (directsso === "Yes") {
                // Send to agreements with redirect
                window.location.replace(
                  `/${reseller_url}/client/agreements?redirect=profile&directsso=yes`
                );
              } else {
                // Default behavior (dashboard)
                window.location.replace(
                  `/${reseller_url}/client/dashboard?redirect=profile`
                );
              }
            } else if (redirect_url === "add_sub_carrier") {
              if (directsso === "Yes") {
                window.location.replace(
                  `/${reseller_url}/client/SubClients/AddSubClient?directsso=yes`
                );
              } else {
                window.location.replace(
                  `/${reseller_url}/client/SubClients/AddSubClient`
                );
              }
            } else if (redirect_url === "service_buy" && service_id) {
              if (directsso === "Yes") {
                window.location.replace(
                  `/${reseller_url}/client/EditSalesOrder/${service_id}?directsso=yes`
                );
              } else {
                window.location.replace(
                  `/${reseller_url}/client/EditSalesOrder/${service_id}`
                );
              }
            } else if (redirect_url === "dashboard") {
              if (directsso === "Yes") {
                window.location.replace(
                  `/${reseller_url}/client/dashboard`
                );
              } else {
                window.location.replace(
                  `/${reseller_url}/client/dashboard`
                );
              }
            } else {
              if (directsso === "Yes") {
                // Send to agreements with redirect
                window.location.replace(
                  `/${reseller_url}/client/${redirect_url}?directsso=yes`
                );
              } else {
                // Default behavior (dashboard)
                window.location.replace(
                  `/${reseller_url}/client/${redirect_url}`
                );
              }
            }
          } else {
            if (directsso === "Yes") {
              window.location.replace(`/${reseller_url}/client/agreements`);
            } else {
              window.location.replace(`/${reseller_url}/client/dashboard`);
            }
          }
        }, 3000);
      } else {
        this.setState({
          errorMessage:
            "Your account cannot be authenticated this time. Please check the URL or try again later.",
          successMessage: "",
        });
      }
    }
  }

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {this.state.errorMessage !== "" ? (
                <div className="example-alert">
                  <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                      <h4>Error</h4>
                      <p>{this.state.errorMessage}</p>
                    </div>
                  </div>
                </div>
              ) : null}

              {/* {this.state.successMessage !== "" ? (
                <div className="example-alert">
                  <div className="alert alert-pro alert-success">
                    <div className="alert-text">
                      <h4>Success</h4>
                      <p>{this.state.successMessage}</p>
                    </div>
                  </div>
                </div>
              ) : null} */}
              <div className="text-center" style={{ marginTop: "20%" }}>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
